import create from "zustand";
import Api from "services2/Api";

export type GlobalFeatureFlags = {
  feMfaLogin: boolean;
};

interface GlobalFeatureState {
  globalFeatures: GlobalFeatureFlags | null;
  getGlobalFeatureFlags: () => Promise<void>;
}

export async function ensureGlobalFlags() {
  const { getGlobalFeatureFlags } = useGlobalFeaturesStore.getState();
  await getGlobalFeatureFlags();                // starts once; reused if already running
  return useGlobalFeaturesStore.getState().globalFeatures;
}

export const useGlobalFeaturesStore = create<GlobalFeatureState>((set) => ({
  globalFeatures: null,
  getGlobalFeatureFlags: async () => {
    try {
      const response = await Api.fetchNoHeaders("/api/system/global-features");
      const data = await response.json();

      set({ globalFeatures: data });
    } catch (error) {
      console.error("Error fetching global feature flags:", error);
    }
  },
}));
